export const WRONG_PAYMENT_KIND_ERROR = /Неверный тип оплаты/;
